import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export function About() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-24" data-testid="about-page">
      <div className="eyebrow mb-6">About</div>
      <h1 className="font-serif-display text-5xl lg:text-6xl text-white leading-tight">
        Built for those who expect <span className="gold-text italic">more</span> from services.
      </h1>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-16">
        <div>
          <h3 className="font-serif-display text-2xl text-white mb-4">The parent platform</h3>
          <p className="text-zinc-400 leading-relaxed">
            RideXelite Services LLC organizes five distinct service verticals under a single,
            technology-driven marketplace. Transport, Delivery, Home, Concierge, and Business —
            each engineered for one thing: consistency.
          </p>
        </div>
        <div>
          <h3 className="font-serif-display text-2xl text-white mb-4">The provider model</h3>
          <p className="text-zinc-400 leading-relaxed">
            Independent providers apply, get vetted, and receive dispatched, paid jobs. The
            platform handles bookings, payments, and dispatch. Providers keep 80% of every
            completed job — no subscription, no hidden fees.
          </p>
        </div>
      </div>

      <div className="mt-24 rounded-3xl border border-white/10 bg-[#121214] p-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 text-center">
          {["Transport","Delivery","Home","Concierge","Business"].map(v => (
            <div key={v} className="font-serif-display text-white text-lg">{v}</div>
          ))}
        </div>
      </div>

      <Link to="/services/transport" className="mt-16 inline-flex items-center gap-2 text-[#D4AF37]">
        Explore services <ArrowRight size={14} weight="bold" />
      </Link>
    </div>
  );
}

export function Contact() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-24" data-testid="contact-page">
      <div className="eyebrow mb-6">Contact</div>
      <h1 className="font-serif-display text-5xl text-white">Two continents. One standard.</h1>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="rounded-2xl border border-white/10 bg-[#121214] p-8">
          <div className="eyebrow gold-text mb-3">Liberia Bookings · Call / WhatsApp Ralph</div>
          <div className="space-y-2 mt-4">
            <a href="tel:+231777689123" data-testid="contact-liberia-primary" className="block text-white font-serif-display text-xl hover:text-[#D4AF37] transition">+231 77 768 9123</a>
            <a href="https://wa.me/231777689123" target="_blank" rel="noopener noreferrer" data-testid="contact-liberia-whatsapp" className="inline-block mt-2 text-xs uppercase tracking-[0.22em] text-[#25D366] hover:text-[#4be089] transition">WhatsApp Ralph →</a>
          </div>
          <div className="mt-6 text-sm text-zinc-500">Marshall, Margibi, Liberia</div>
        </div>
        <div className="rounded-2xl border border-[#D4AF37]/30 bg-[#121214] p-8">
          <div className="eyebrow gold-text mb-3">USA Bookings · Call / WhatsApp Charles</div>
          <a href="tel:+14436836392" data-testid="contact-usa-primary" className="block text-white font-serif-display text-3xl hover:text-[#D4AF37] transition">443-683-6392</a>
          <a href="https://wa.me/14436836392" target="_blank" rel="noopener noreferrer" data-testid="contact-usa-whatsapp" className="inline-block mt-2 text-xs uppercase tracking-[0.22em] text-[#25D366] hover:text-[#4be089] transition">WhatsApp Charles →</a>
          <div className="mt-8 text-sm text-zinc-300 space-y-2">
            <div>support@ridexelite.com</div>
            <div>ridexafrica@outlook.com</div>
          </div>
        </div>
      </div>
      <p className="mt-12 text-zinc-500 text-sm">Daily, weekly, and monthly rentals available. Support 24/7 for active bookings.</p>
    </div>
  );
}
